import { Button } from '../button'
import Modal from '../modal'

export default function MessageModal({ title, text, onClose }) {
  return (
    <Modal onClose={onClose} closeOnClickOutside={false} hideCloseBtn>
      <div className='message flex flexDirectionColumn alignCenter'>
        <h2>{title}</h2>
        <p>{text}</p>
        <Button className='close' onClick={onClose}>
          Close
        </Button>
      </div>

      <style jsx>{`
        .message {
          padding: 2.6rem 5rem 4rem;
          background: var(--secondary-bg-color);

          h2 {
            font-size: 3.2rem;
          }

          p {
            margin: 2.4rem 5rem 4rem;
            font-size: 1.6rem;
            text-align: center;
          }
        }

        @media (max-width: 1024px) {
          .message {
            padding: 5.4rem 2rem;

            h2 {
              font-size: 1.8rem;
            }

            p {
              margin: 0.8rem 0;
              font-size: 1.4rem;
            }

            :global(.close) {
              position: fixed;
              bottom: 2.1rem;
              width: calc(100% - 2.8rem);
            }
          }
        }
      `}</style>
    </Modal>
  )
}
